
export type ToolPageKey =
  | "FGT" | "DCR" | "FMX" | "FDM" | "FDX" | "SHX" | "SHXCUL"
  | "SC" | "DISC" | "TRIMX" | "STP"
  | "STP220" | "STP240" | "STP280" | "STP3500" | "STP360";

const normalize = (s?: string) => s?.trim().toUpperCase() ?? "";

/** Mapping from productCodeType → Tool Page key (derived from your Excel) */
const MAP: Record<string, ToolPageKey> = {
  // ------- EXCCM family -------
  "BH-EXCCM_DCR": "DCR",
  "BH-EXCCM_FC": "FGT",
  "BH-EXCCM_FS": "FGT",
  "BH-EXCCM_S":  "FGT",
  "BH-EXCCM_FR": "FGT",
  "BH-EXCCM_C":  "FGT",

  // ------- EXCFX -------
  "BH-EXCFX_FC": "FMX",
  "BH-EXCFX_FS": "FMX",

  // ------- EXCHD -------
  "BH-EXCHD_DCR": "DCR",
  "BH-EXCHD_FC":  "FGT",
  "BH-EXCHD_FR":  "FGT",
  "BH-EXCHD_FS":  "FGT",
  "BH-EXCHD_S":   "FGT",

  // ------- EXCSD -------
  "BH-EXCSD_DCR": "DCR",
  "BH-EXCSD_FC":  "FGT",
  "BH-EXCSD_FS":  "FGT",
  "BH-EXCSD_S":   "FGT",
  "BH-EXCSD_FR":  "FGT",
  "BH-EXCSD_V":   "STP220",

  // ------- HHD/HSD -------
  "BH-HHD_FS":        "STP240",
  "BH-HHD-OEM_FS":    "STP280",
  "BH-HSD_DCR":       "DCR",
  "BH-HSD_FS":        "STP3500",
  "BH-HSD_S":         "STP360",
  "BH-HSD_DCRA":      "FGT",        // If this should be DCR variant, tell me and I’ll update.

  // ------- BK & BKSD (SSL/CTL Bull Hog) -------
  "BH-BK/SS_FCR":     "FGT",        // Excel shows FGT + DCR tools; primary page = FGT
  "BH-BK/SS_PROTO":   "DCR",
  "BH-BK-SD_FCR":     "DCR",

  // ------- SF/SS -------
  "BH-SF/SS_FC":      "FMX",        // If this should be TRIMX, let me know; Excel shows both FMX/TRIMX context
  "BH-SF/SS_FS":      "FMX",

  // ------- SS families -------
  "BH-SS_DCR":        "DCR",
  "BH-SS_FC":         "FGT",
  "BH-SS_FS":         "FGT",
  "BH-SS_S":          "FGT",
  "BH-SS_N":          "FGT",
  "BH-SS_DCRB":       "DCR",
  "BH-SS_FR":         "FGT",
  "BH-SS_R":          "FGT",
  "BH-SS_FSD":        "FGT",

  // ------- SS-SD -------
  "BH-SS-SD_DCR":     "DCR",
  "BH-SS-SD_FC":      "FGT",
  "BH-SS-SD_FS":      "FGT",

  // ------- Standalone tool pages / rotors -------
  "FDM":              "FDM",
  "FDX":              "FDX",
  "SH-X":             "SHX",
  "SH-XCUL":          "SHXCUL",
  "SS-CRUSH":         "SC",
  "SS-DISC":          "DISC",
  "SS-TRIM":          "TRIMX",

  // ------- STP variants -------
  "STP220":           "STP220",
  "STP240":           "STP240",
  "STP280":           "STP280",
  "STP3500":          "STP3500",
  "STP360":           "STP360",
};

/** Resolve Tool Page for a productCodeType */
export function toolPageForProductCodeType(productCodeType?: string): ToolPageKey | null {
  const key = normalize(productCodeType);
  return MAP[key] ?? null;
}
